import { defineMessages } from "react-intl";

import VideoGuideDescriptor from "@app/component/flows/types/VideoGuideDescriptor";

// Every video lives under the same CloudFront prefix, with its folder and file sharing a
// stem: <name>/<name>_master.m3u8.
const VIDEO_BASE_URL = "https://dje104t1n0kqw.cloudfront.net/videos";
const videoUrl = (name: string) => `${VIDEO_BASE_URL}/${name}/${name}_master.m3u8`;

const messages = defineMessages({
  activitiesTips: {
    id: "guides.tristate.activitiesTips",
    defaultMessage: "Activities: Tips and Tricks",
    description: "Title of the Tri-State activities training video guide",
  },
  activitiesTipsDescription: {
    id: "guides.tristate.activitiesTips.description",
    defaultMessage: "Get more out of activities, from logging them to keeping them on track.",
    description: "Description of the Tri-State activities training video guide",
  },
  checkIns: {
    id: "guides.tristate.checkIns",
    defaultMessage: "Customer Check-Ins",
    description: "Title of the Tri-State check-ins training video guide",
  },
  checkInsDescription: {
    id: "guides.tristate.checkIns.description",
    defaultMessage: "How to record a check-in when you visit a customer.",
    description: "Description of the Tri-State check-ins training video guide",
  },
  editCompanyRecords: {
    id: "guides.tristate.editCompanyRecords",
    defaultMessage: "Editing Company Records",
    description: "Title of the Tri-State company records training video guide",
  },
  editCompanyRecordsDescription: {
    id: "guides.tristate.editCompanyRecords.description",
    defaultMessage: "How to update a company's details by hand.",
    description: "Description of the Tri-State company records training video guide",
  },
  leadFinder: {
    id: "guides.tristate.leadFinder",
    defaultMessage: "Lead Finder",
    description: "Title of the Tri-State lead finder training video guide",
  },
  leadFinderDescription: {
    id: "guides.tristate.leadFinder.description",
    defaultMessage: "How to find and add new leads around you.",
    description: "Description of the Tri-State lead finder training video guide",
  },
  routesAndDirections: {
    id: "guides.tristate.routesAndDirections",
    defaultMessage: "Routes and Directions",
    description: "Title of the Tri-State routes training video guide",
  },
  routesAndDirectionsDescription: {
    id: "guides.tristate.routesAndDirections.description",
    defaultMessage: "How to plan a route and get directions to your stops.",
    description: "Description of the Tri-State routes training video guide",
  },
});

// Each `id` MUST exactly match the `frigadeFlowId` stored on the corresponding Guide
// record, otherwise the guide falls through to Frigade and its video never opens.
const triStateVideoGuides: VideoGuideDescriptor[] = [
  {
    id: "mmc-tristate-activities-tips",
    description: messages.activitiesTipsDescription,
    title: messages.activitiesTips,
    url: videoUrl("MapMyCustomers-TriStateActivitiesTipsandTricks"),
  },
  {
    id: "mmc-tristate-check-ins",
    description: messages.checkInsDescription,
    title: messages.checkIns,
    url: videoUrl("MapMyCustomers-CustomerCheckIn"),
  },
  {
    id: "mmc-tristate-edit-company-records",
    description: messages.editCompanyRecordsDescription,
    title: messages.editCompanyRecords,
    url: videoUrl("MapMyCustomers-EditCompanyRecordsManually"),
  },
  {
    id: "mmc-tristate-lead-finder",
    description: messages.leadFinderDescription,
    title: messages.leadFinder,
    url: videoUrl("MapMyCustomers-LeadFinder"),
  },
  {
    id: "mmc-tristate-routes-and-directions",
    description: messages.routesAndDirectionsDescription,
    title: messages.routesAndDirections,
    url: videoUrl("MapMyCustomersRoutesandDirections"),
  },
];

export default triStateVideoGuides;
